import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import {store} from './store'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import axios from 'axios'
import VueAxios from 'vue-axios'
import browserDetect from "vue-browser-detect-plugin";
import genericImageUploader from "@/components/shared/genericImageUploader";
import ImageUploader from 'vue-image-upload-resize'
// import firebase from 'firebase/compat/app'
// import 'firebase/compat/auth';



// components
import alart from './components/shared/Alert.vue'
import appLoading from './components/shared/loading.vue'
import locationPicker from './components/shared/locationPicker'
import locationsAutocomplete from './components/shared/locationAutoComplete'
import datePicker from "./components/shared/dateTimePicker"
import imageItemRecognition from "@/components/shared/ImageItemRecognition";
import phoneUi from './components/shared/signUserInWithPhone'
import addOnItemPicker from "@/components/shared/addOnItemPicker";
import myListButton from "@/components/listing/myListBadge"


// third party components
Vue.use(VueAxios, axios)

Vue.use(browserDetect);
// shared components
Vue.component('app-alert', alart)
Vue.component('app-loading', appLoading)
Vue.component('get-location-app', locationPicker)
Vue.component('locations-autocomplete', locationsAutocomplete)
Vue.component('date-time-picker', datePicker)
Vue.component('gen-img-uploader', genericImageUploader)
Vue.component('img-item-recog', imageItemRecognition)
Vue.component('phone-ui', phoneUi)
Vue.component('addon-item-picker', addOnItemPicker)
Vue.component('my-list-button', myListButton)


Vue.use(ImageUploader);

const auth = getAuth()

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
  created () {
    this.$store.dispatch('coldStartCloudFunctions')
    onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log(user.uid)
          if(!user.isAnonymous) {
            console.log('Verfied user')
            this.$store.dispatch('fetchUserData', user)
          } else {
            console.log('anon user')
            this.$store.dispatch('fetchAnonUserData', user)
          }
        } else {
        this.$store.dispatch('signupAnon')
      }
      })
    }

}).$mount('#app')
